import { MouseEvent, useEffect } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import Skeleton from '@/components/common/Skeleton/Skeleton';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { useGetCustomerName } from './useGetCustomerName';

interface IFilteredByPurchaseOrderBreadcrumb {
  defaultText: string;
  path: string;
}

export default function ContractLinesFilteredByCustomerBreadcrumb({
  defaultText,
  path,
}: IFilteredByPurchaseOrderBreadcrumb) {
  const history = useHistory();
  const invoiceToAccountId = new URL(window.location.href).searchParams.get('invoiceToAccountId') ?? '';
  const invoiceToAccountNumber = new URL(window.location.href).searchParams.get('invoiceToAccountNumber') ?? '';
  const poNumber = new URL(window.location.href).searchParams.get('poNumber') ?? '';
  const poCurrency = new URL(window.location.href).searchParams.get('poCurrency') ?? '';
  const { customerName, error, getCustomerName, isLoading } = useGetCustomerName();

  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;
    const isGridFilteredByPoPage = matchPath(pathName, {
      path: path,
      exact: true,
    });

    if (isGridFilteredByPoPage) {
      window.location.reload();
    }
    else {
      const link = getParameterizedLink(
        `${path}?invoiceToAccountNumber=${invoiceToAccountNumber}` +
        `&invoiceToAccountId=${invoiceToAccountId}` +
        `&poNumber=${poNumber}` +
        `&poCurrency=${poCurrency}`
      );
      history.push(link);
    }
  };

  useEffect(() => {
    if (invoiceToAccountId) {
      getCustomerName(invoiceToAccountId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceToAccountId]);


  if (isLoading) {
    return <Skeleton width={100} />;
  }

  if (error || !customerName) {
    return <>{defaultText}</>;
  }

  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {`Contract Lines filtered by invoiced customer: ${customerName}`}
    </a>
  );
}
